<template>
  <div id="header" class="header-container">
    <div class="navbar-container">
      <div class="profile-container">
        <div>{{ email }} {{ fullname }}</div>
        <div>(Login time: {{ loginTime }})</div>
      </div>
      <div class="navbar-right-container">
        <Slide
          class="menu-container"
          right
          noOverlay
          :isOpen="isOpenMenu"
          @openMenu="isOpenMenu = true"
          disableOutsideClick
          v-on-click-outside="handleCloseMenu"
        >
          <!-- Homepage -->
          <router-link to="/home" @click.native="handleCloseMenu()">
            หน้าหลัก
          </router-link>

          <!-- Sale Menu -->
          <div class="menu-item" @click="isOpenSaleSubMenu = !isOpenSaleSubMenu">
            การขาย <span class="caret"></span>
          </div>
          <div class="sub-menu" v-show-slide="isOpenSaleSubMenu">
            <div class="sub-menu-item">
              <router-link to="/quotation" @click.native="handleCloseMenu()">
                ใบเสนอราคา
              </router-link>
            </div>
            <div class="sub-menu-item">
              <router-link to="/draft" @click.native="handleCloseMenu()">
                จัดการบันทึกฉบับร่าง
              </router-link>
            </div>
            <div class="sub-menu-item">
              <router-link to="/manage_app" @click.native="handleCloseMenu()">
                จัดการใบคำขอ
              </router-link>
            </div>
          </div>

          <!-- Report Menu -->
          <div class="menu-item" @click="isOpenReportMenu = !isOpenReportMenu">
            รายงาน <span class="caret"></span>
          </div>
          <div class="sub-menu" v-show-slide="isOpenReportMenu">
            <div class="sub-menu-item">
              <router-link to="/report_daily" @click.native="handleCloseMenu()">
                รายงานยอดขายของพนักงาน
              </router-link>
            </div>
            <div class="sub-menu-item" v-if="scoped !== 'sale'">
              <router-link to="/report_branch" @click.native="handleCloseMenu()">
                ยอดขายประจำสาขา
              </router-link>
            </div>
            <div class="sub-menu-item" v-if="scoped !== 'sale' && scoped !== 'manager_branch'">
              <router-link to="/report_district" @click.native="handleCloseMenu()">
                ยอดขายประจำเขต
              </router-link>
            </div>
          </div>

          <!-- Referrer Menu -->
          <router-link to="/manage_referrer" @click.native="handleCloseMenu()">
            จัดการข้อมูล Referrer
          </router-link>

          <!-- Back Office Menu -->
          <div v-if="scoped === 'all'">
            <router-link to="/tvi/issued" @click.native="handleCloseMenu()">
              Back Office
            </router-link>
          </div>

          <!-- Guide Menu -->
          <div class="menu-item" @click="isOpenGuideMenu = !isOpenGuideMenu">
            คู่มือการใช้งาน <span class="caret"></span>
          </div>
          <div class="sub-menu" v-show-slide="isOpenGuideMenu">
            <div class="sub-menu-item">
              <a
                target="_blank"
                :href="generateUrl(individualManualEndpoint)"
                @click.native="handleCloseMenu()"
              >
                คู่มือการใช้งานการทำประกันรายบุคคล
              </a>
            </div>
            <div class="sub-menu-item">
              <a
                target="_blank"
                :href="generateUrl(familyManualEndpoint)"
                @click.native="handleCloseMenu()"
              >
                คู่มือการใช้งานการทำประกันครอบครัว
              </a>
            </div>
          </div>

          <!-- Brochure Menu -->
          <a
            target="_blank"
            :href="generateUrl(brochureEndpoint)"
            @click.native="handleCloseMenu()"
          >
            โบรชัวร์
          </a>

          <!-- Logout Button -->
          <div class="logout-btn-container" @click="logout">
            Logout
          </div>
        </Slide>
      </div>
    </div>
    <div class="partner-container">
      <div class="tmb-information-container">
        <div class="logo-container">
          <img class="logo-img" src="../assets/images/logo/logo_ttb.png" />
        </div>
        <div class="information-text">
          รับประกันวินาศภัยโดย บริษัทประกันภัยไทยวิวัฒน์ จำกัด (มหาชน)
          <br />
          ธนาคารทหารไทยธนชาต จำกัด (มหาชน) เป็นเพียงนายหน้าประกันวินาศภัย
          <br />
          และรับผิดชอบในฐานะนายหน้าเท่านั้น
        </div>
      </div>
      <div class="tvi-information-container">
        <div class="logo-container">
          <img class="logo-img" src="../assets/images/logo_thaivivat.jpg" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import API from '@/lib/api'
import { mapGetters } from 'vuex'
import { Slide } from 'vue-burger-menu'
import { generatePdfViewerUrl, generateAuthorizationRequestHeader } from '@/lib/services'

export default {
  components: {
    Slide,
  },
  name: 'Header',
  data: () => ({
    scoped: null,
    authFrom: null,
    isOpenMenu: false,
    isOpenSaleSubMenu: false,
    isOpenReportMenu: false,
    isOpenGuideMenu: false,
    currentDomain: '',
    individualManualEndpoint: API.DOCUMENTS.INDIVIDUAL_MANUAL,
    familyManualEndpoint: API.DOCUMENTS.FAMILY_MANUAL,
    brochureEndpoint: API.DOCUMENTS.INSURANCE_BROCHURE,
    email: '',
    fullname: '',
    loginTime: '',
  }),
  watch: {
    isOpenSaleSubMenu(val) {
      if (val) {
        this.isOpenReportMenu = false
        this.isOpenGuideMenu = false
      }
    },
    isOpenReportMenu(val) {
      if (val) {
        this.isOpenSaleSubMenu = false
        this.isOpenGuideMenu = false
      }
    },
    isOpenGuideMenu(val) {
      if (val) {
        this.isOpenSaleSubMenu = false
        this.isOpenReportMenu = false
      }
    },
  },
  mounted() {
    const isSessionChiliExist = this.$session.has('chili')

    if (isSessionChiliExist) {
      this.scoped = this.checkScoped(this.$session.get('chili').scoped)
      this.authFrom = this.$session.get('chili').auth_from
      this.currentDomain = this.env.VUE_APP_LOCATION
      this.email = _.get(this.$session.get('chili'), 'email', '')
      this.fullname = _.get(this.$session.get('chili'), 'name', '')
      this.loginTime = _.get(this.$session.get('chili'), 'loginTime', '')
    }
  },
  computed: {
    ...mapGetters(['checkScoped', 'env']),
  },
  methods: {
    handleCloseMenu() {
      this.isOpenMenu = false
      this.isOpenSaleSubMenu = false
      this.isOpenReportMenu = false
      this.isOpenGuideMenu = false
    },
    generateUrl: generatePdfViewerUrl,
    logout() {
      this.$http
        .post(
          API.AUTHORIZATION.LOGOUT,
          {},
          {
            headers: {
              ...generateAuthorizationRequestHeader(),
            },
          },
        )
        .then(
          response => {
            let res = response.body
            if (this.$session.has('chili')) {
              if (this.$session.get('chili').auth_from === 'tmb') {
                this.$session.destroy()
                var cookies = document.cookie.split(';')
                for (var i = 0; i < cookies.length; i++) {
                  var equals = cookies[i].indexOf('=')
                  var name = equals > -1 ? cookies[i].substr(0, equals) : cookies[i]
                  document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT'
                }
                let url = this.env.VUE_APP_TMB_LOGOUT_URL + this.env.VUE_APP_LOCATION
                //'https://servicesdd.tmbbank.com/adfs/ls?wa=wsignout1.0';
                window.location.assign(url)
              } else {
                this.$session.destroy()
                let routeData = this.$router.resolve({ path: '/' })
                window.open(routeData.href, '_self')
              }
            } else {
              this.$session.destroy()
              let routeData = this.$router.resolve({ path: '/' })
              window.open(routeData.href, '_self')
            }
          },
          error => {
            if (this.$session.has('chili')) {
              if (this.$session.get('chili').auth_from === 'tmb') {
                this.$session.destroy()
                let cookies = document.cookie.split(';')
                for (let i = 0; i < cookies.length; i++) {
                  let equals = cookies[i].indexOf('=')
                  let name = equals > -1 ? cookies[i].substr(0, equals) : cookies[i]
                  document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT'
                }
                let url = this.env.VUE_APP_TMB_LOGOUT_URL + this.env.VUE_APP_LOCATION
                //'https://servicesdd.tmbbank.com/adfs/ls?wa=wsignout1.0';
                window.location.assign(url)
              } else {
                this.$session.destroy()
                let routeData = this.$router.resolve({ path: '/' })
                window.open(routeData.href, '_self')
              }
            } else {
              this.$session.destroy()
              let routeData = this.$router.resolve({ path: '/' })
              window.open(routeData.href, '_self')
            }
          },
        )
    },
  },
}
</script>

<style lang="scss">
#header {
  .navbar-container {
    background-color: #ebeff2;
    min-height: 52px;
    padding: 8px 16px;
    position: relative;
    text-align: right;

    .profile-container {
      color: #666666;
      display: inline-block;
      font-size: 12px;
      line-height: 16px;
      margin-right: 50px;
      text-align: center;
    }

    .navbar-right-container {
      .menu-container {
        text-align: left;

        .email-address-section {
          display: flex;
          flex-direction: column;
          justify-content: center;
          margin-top: 15px;
          margin-right: 30px;
        }

        .menu-item {
          align-items: center;
          cursor: pointer;
        }

        .sub-menu {
          display: block;
          padding: 0;

          .sub-menu-item {
            padding: 0.7em 0.7em 0.7em 1.8em;
          }
        }

        .bm-menu {
          background-color: #fff;

          .bm-item-list {
            color: #828282;
            font-size: 18px;

            span {
              color: #828282;
            }
          }
        }

        .bm-burger-button {
          height: 20px;
          right: 20px !important;
          top: 50%;
          transform: translate(0, -50%);
          width: 28px;

          .bm-burger-bars {
            background-color: #00a350;
            border-radius: 3px;
          }
        }
      }

      .login-time {
        font-size: 12px;
        text-align: center;
      }
    }
  }

  .partner-container {
    align-items: center;
    background-color: #ffffff;
    box-shadow: 0 4px 10px 0 rgba(52, 73, 94, 0.2);
    display: flex;
    grid-template-columns: minmax(210px, 1.5fr) 1fr;
    justify-content: space-between;
    margin-bottom: 4px;
    padding: 16px;

    .tmb-information-container {
      align-items: center;
      display: flex;
      font-family: 'psl_kandabold', serif;
      font-size: 14px;
      line-height: 18px;

      .logo-container {
        margin-right: 8px;
      }

      .information-text {
        color: #000000;
        display: inline-block;
      }
    }

    .tvi-information-container {
      font-family: 'psl_kandabold', serif;
      font-size: 14px;
      line-height: 18px;
      text-align: right;

      .logo-container {
        margin-left: 8px;
      }
    }

    .logo-container {
      display: inline-block;

      .logo-img {
        display: inline-block;
        height: 48px;
      }
    }
  }
}
</style>
